module.exports = __webpack_public_path__ + "media/images/smart-7aafbb47157bb75aa347b3bcb2fcf2aa.png";